import fonts from 'assets/fonts';

const generateFontWithWeight = (weight: FontWeightT, lang: 'fa' | 'en') => {
  switch (weight) {
    case 'thin':
      return fonts[lang].thin;
    case 'light':
      return fonts[lang].light;
    case 'default':
      return fonts[lang].default;
    case 'medium':
      return fonts[lang].medium;
    case 'bold':
      return fonts[lang].bold;
    case 'extraBold':
      return fonts[lang].extraBold;
    case 'black':
      return fonts[lang].black;
    case 'extraBlack':
      return fonts[lang].extraBlack;
    default:
      return fonts[lang].default;
  }
};

export default generateFontWithWeight;
